$('.sub_prod').click(function(){
	var prodId = $(this).attr('value');  
    $('#id').val(prodId);
}); 

const calculateSale = (listPrice, discount) => {
  listPrice = parseFloat(listPrice);
  discount  = parseFloat(discount);
  return (listPrice - ( listPrice * discount / 100 )).toFixed(2); 
}

$('.pro_jar_one').click(function(){
	var prodPrice = $(this).attr('data-price-one');
    var salePrice = calculateSale(prodPrice,25);
    $('.sub_sale_price').text('$'+salePrice);  	
  	$('.sub_price_diff').text('$'+(prodPrice-salePrice).toFixed(2));  	
}); 


//Smooth scrolling
$('.rvw_area').on('click', function () {
  $('html, body').animate({
    scrollTop: $('#stamped-main-widget').offset().top - 150
  }, 200);
});

$('.sticky_order_btn, .order_now').on('click', function () {
  $('html, body').animate({
    scrollTop: $('.radio_title_wrap').offset().top - 150
  }, 200);
});

var total_cost = 63.34;
var upCount = 2;

$(document).ready(function (){

  $('.total_cost').html(total_cost.toFixed(2));
  $('.total_cost').val(total_cost);  
  $('.upsell-btn').html('Add All to Cart');  
  $('.default_selected').addClass("act_blu");
  
  $('.defSelPriceOne').click();
  $('.defSelPriceSub').click();
  //$('.subs_note').hide();
  $('.newSubForm').attr('id','40544236372119');
  $('.def_prod').attr('value','40544236372119');
  $('#type').attr('value','one_time');
  $('.one_time_purchase_content').hide();
});

$('.upsell_check').on('change', function () {
  
  	if($(this).prop('checked') == false){
    	upCount = upCount-1;
      	total_cost = parseFloat(total_cost)-parseFloat($(this).attr('price'));
      	$('.total_cost').html(total_cost.toFixed(2)); 
      	$('.total_cost').val(total_cost);      	
	} else {
      	upCount = upCount+1;
      	total_cost = parseFloat(total_cost)+parseFloat($(this).attr('price'));      
      	$('.total_cost').html(total_cost.toFixed(2)); 
      	$('.total_cost').val(total_cost);	
	}  
  
    if(upCount == 2){
      $('.upsell-btn').html('Add All to Cart');
    }else{
      $('.upsell-btn').html('Add To Cart');
    }  
  
});

var langArray = [];
$('.vodiapicker option').each(function(){
  var img = $(this).attr("data-thumbnail");
  var text = this.innerText;
  var value = $(this).val();
  var days_value = $(this).attr('data-days');
  var shipping="Ships Every 30 days";
  var item = '<li><img days_value="'+days_value+'" src="'+ img +'" alt="" value="'+value+'"/><span>'+ text +'</span></li>';
  langArray.push(item);
})

$('#a').html(langArray);

//Set the button value to the first el of the array
$('.btn-select ul').html(langArray[1]);
$('.btn-select ul').attr('value', 'en');
$(".btn-select div.extrap").html("");

// 25-11-2021 //
$('.vodiapicker').on('change', function() {
  var subs_day = $('option:selected', this).attr('data-days');
  //alert(subs_day);
  $('#duration').val(subs_day);
  $.session.set("sub_duration", subs_day);
});
// end //

//change button stuff on click
$('#a li').click(function(){
  
  var img = $(this).find('img').attr("src");
  var value = $(this).find('img').attr('value');  
  days_select = $(this).find('img').attr('days_value');
  
  $('#duration').val($(this).find('img').attr('days_value'));
  
  var text = this.innerText;
  
  var shipping="Ships Every 30 days";
  var item = '<li><img src="'+ img +'" alt="" /><span>'+ text +'</span></li>';  
  $('.btn-select ul').html(item);
  $('.btn-select ul').attr('value', value);
  $(".b").toggle();
  $(".btn-select>span").removeClass("arrow");
  $(".btn-select div.extrap").html("");

  $.session.set("sub_duration", days_select);
    
});

$(".btn-select>span").click(function(){
  $(".b").toggle();
  $(".btn-select>span").toggleClass("arrow");

});

//check local storage for the lang
var sessionLang = localStorage.getItem('lang');
if (sessionLang){
  //find an item with value of sessionLang
  var langIndex = langArray.indexOf(sessionLang);
  $('.btn-select ul').html(langArray[langIndex]);
  $('.btn-select ul').attr('value', sessionLang);
} else {
   var langIndex = langArray.indexOf('ch');
  console.log(langIndex);
  $('.btn-select ul').html(langArray[langIndex]);
  //$('.btn-select').attr('value', 'en');
}

// mobile scroll button hide
$(window).scroll(function(){
  var height = $(this).scrollTop();
  if(height > 9700) {
      $('.show_btn_on_mobile').css('display','none');
  } else {
      $('.show_btn_on_mobile').css('display','block');
  } 
});


$(".what_size>span").hover(function(){
    $('.hvr_guide').show();
},function(){
    $('.hvr_guide').hide();
});


$('.radio_wrap').click(function(){
  $('.radio_wrap').removeClass('radio_wrap_active');
  $(this).addClass('radio_wrap_active');
});

localStorage.setItem("type", "subscription");

$(".head_radio").click(function(){
  
  	console.log ("ONE-TIME AND SUBSC SWITCHING...");
 
    $(this).closest('.radio-type_wrap').find('.radio_title_wrap').removeClass('radio_show');
    $(this).closest('.radio_wrap').find('.radio_title_wrap').toggleClass('radio_show');
  	$(this).closest('.radio-type_wrap').find('.dog_size_select').removeClass('radio_box_show');
   	$(this).closest('.radio_wrap').find('.dog_size_select').toggleClass('radio_box_show');
  	
  	$('#type').val($(this).attr('categry'));
  
  	localStorage.setItem("type", $(this).attr('categry'));
  
//     $(".pro_jar_one, .pro_jar_sub").each(function() {
//       $(this).removeClass("act_blu");        
//     });

  
//    	$('.default_selected').addClass("act_blu");
  
   if($(this).attr('categry')=='one_time') {
     
      $('.subs_note').show();
      
      // 02-12-2021 //		
      var current_sub_pack = '';
      $(".pro_jar_sub").each(function() {
     	if($(this).hasClass("act_blu"))
        {
          current_sub_pack = $(this).attr('sub_option');
        }
      });
      
      $(".pro_jar_one").each(function() {
        
      	$(this).removeClass("defSelPriceOne");	
        var one_time_pack = $(this).attr('onetime_option');
        if(one_time_pack == current_sub_pack)
        {
           $(this).addClass("defSelPriceOne");
           $('.newSubForm').attr('id',$(this).attr('variant_one'));
           var variant_id = $(this).attr('variant_one');
  		   $('.variant_input').val(variant_id);
           $('.def_prod').val(variant_id);
          
            if(one_time_pack == 2 || one_time_pack == 3){
                $('.one_time_purchase_content').show();
            }
            else{
                $('.one_time_purchase_content').hide();
            }
            $('#pack').val(one_time_pack+'-Pack');
        }
      
      });
      // end //
     
      // 25-11-2021 //
       $('.one_price_show').show();
       $('.subs_price_show').hide();
       $('.save_prc_sub').hide();
       $('.subs_products').hide();
       $('.one_time_products').show();
       $('.sbscrbe_save_content').hide();
       
       // end //
      var dataPrice = $('.defSelPriceOne').attr('data-price-one');       
      var salePrice = calculateSale(dataPrice,25);
      $('.sub_sale_price').text('$'+salePrice);
      $('.sub_price_diff').text('$'+(dataPrice-salePrice).toFixed(2));
      
      //$('.buy_txt').html('Add To Cart <img class="loader_icon" style="display:none;" src="https://cdn.shopify.com/s/files/1/0300/3180/6597/files/lodd.gif?v=1620831380">');     
      
      // 25-11-2021 //
      $('.buy_txt').html('Add To Cart<span class="btn_arrow"><img src="https://cdn.shopify.com/s/files/1/0300/3180/6597/files/right_arrow.png?v=1637820901" alt="Arrow"></span><img class="loader_icon" style="display:none;" src="https://cdn.shopify.com/s/files/1/0300/3180/6597/files/lodd.gif?v=1620831380">');     
      // end //
     
      //$('.def_prod').val('40544236372119');
     
     	$('.now_price_one').html('$'+$('.defSelPriceOne').attr('data-price-one'));
		$('.old_prce_one').html('<s>$'+$('.defSelPriceOne').attr('old-price-one')+'</s>');
		$('.save_prc_one').html("You're Saving "+$('.defSelPriceOne').attr('save_price'));
   } else {
     
      $('.subs_note').hide();
     
      // 02-12-2021 //		
      var current_one_time_pack = '';
      $(".pro_jar_one").each(function() {
     	if($(this).hasClass("act_blu"))
        {
          current_one_time_pack = $(this).attr('onetime_option');
        }
      });
      
      $(".pro_jar_sub").each(function() {
        
      	$(this).removeClass("defSelPriceSub");	
        var sub_pack = $(this).attr('sub_option');
        if(sub_pack == current_one_time_pack)
        {
           $(this).addClass("defSelPriceSub");
           let variantId = $(this).find('.sub_prod').attr('prod-id');
           $('.variant_input').val(variantId);
      	   $('.def_prod').val(variantId);
           $('#pack').val(sub_pack+'-Pack');
        }
      
      });
      // end //
     
      // 25-11-2021 //
      $('.one_price_show').hide();
      $('.one_time_products').hide();
      $('.one_time_purchase_content').hide();
      // end //
     
      //$('.buy_txt').html('Add To Cart <img class="loader_icon" style="display:none;" src="https://cdn.shopify.com/s/files/1/0300/3180/6597/files/lodd.gif?v=1620831380">');
      // 25-11-2021 //
      $('.buy_txt').html('Add To Cart<span class="btn_arrow"><img src="https://cdn.shopify.com/s/files/1/0300/3180/6597/files/right_arrow.png?v=1637820901" alt="Arrow"></span><img class="loader_icon" style="display:none;" src="https://cdn.shopify.com/s/files/1/0300/3180/6597/files/lodd.gif?v=1620831380">');
      // end //
     
      //$('.def_prod').val('40544943538327');
     
     	$('.now_price_sub').html('$'+$('.defSelPriceSub').attr('data-price-sub'));
		$('.old_prce_sub').html('<s>$'+$('.defSelPriceSub').attr('old-price-sub')+'</s>'); 
		$('.save_prc_sub').html("You're Saving "+$('.defSelPriceSub').attr('save_price'));
     
     	// 25-11-2021 //
     	$('.old_price_text').html('<s>$'+$('.defSelPriceSub').attr('old-price-sub')+'</s>');
     	$('.saving_prc').html("You're SAVING "+$('.defSelPriceSub').attr('save_price'));
     	// end //
     
        $('.subs_price_show').show();
        $('.save_prc_sub').show();
        $('.subs_products').show();
        $('.sbscrbe_save_content').show();
   }
  
});

$(".pro_jar_one").click(function(){

 	$('.newSubForm').attr('id',$(this).attr('variant_one'));
    
  	$(this).closest('.radio-type_wrap').find('.pro_jar_one').removeClass('act_blu');
    $(this).addClass('act_blu');
  	$('.now_price_one').html('$'+$(this).attr('data-price-one'));
  	$('.old_prce_one').html('<s>$'+$(this).attr('old-price-one')+'</s>');
  	$('.save_prc_one').html("You're Saving "+$(this).attr('save_price'));
  	//add to cart
  	var variant_id = $(this).attr('variant_one');
  	
  	$('.def_prod').val(variant_id);
    
    var onetime_option = $(this).attr('onetime_option');
    if(onetime_option == 2 || onetime_option == 3){
		$('.one_time_purchase_content').show();
    }
  	else{
        $('.one_time_purchase_content').hide();
  	}
    $('#pack').val(onetime_option+'-Pack');
    // 02-12-2021 //
  
  	var current_one_time_pack = $(this).attr('onetime_option');
  	
  	$(".pro_jar_sub").each(function() {
      $(this).removeClass("defSelPriceSub");
      $(this).removeClass("act_blu");
      var sub_pack = $(this).attr('sub_option');
      
      if(sub_pack == current_one_time_pack)
      {
        $(this).closest('.radio-type_wrap').find('.pro_jar_sub').removeClass('act_blu');
        $(this).addClass('act_blu');
        $('.now_price_sub').html('$'+$(this).attr('data-price-sub'));
        $('.old_prce_sub').html('<s>$'+$(this).attr('old-price-sub')+'</s>');

        $('.save_prc_sub').html("You're Saving $"+$(this).attr('save_price'));

        // 25-11-2021//
        $('.old_price_text').html('<s>$'+$(this).attr('old-price-sub')+'</s>');
        $('.saving_prc').html("You're SAVING $"+$(this).attr('save_price'));
        // end //

        $.session.set("sub_prod_id", $(this).find('.sub_prod').attr('prod-id'));
        //alert($.session.get("sub_prod_id"));
      }
    });
  
  	// End //

});

$(".pro_jar_sub").click(function(){

  var variantId = $(this).find('.sub_prod').attr('prod-id');

  $('.newSubForm').attr('id',variantId);
  $('.def_prod').val(variantId);
  
  $(this).closest('.radio-type_wrap').find('.pro_jar_sub').removeClass('act_blu');
  $(this).addClass('act_blu');
  $('.now_price_sub').html('$'+$(this).attr('data-price-sub'));
  $('.old_prce_sub').html('<s>$'+$(this).attr('old-price-sub')+'</s>');
 
  $('.save_prc_sub').html("You're Saving "+$(this).attr('save_price'));
  
  // 25-11-2021//
  $('.old_price_text').html('<s>$'+$(this).attr('old-price-sub')+'</s>');
  $('.saving_prc').html("You're SAVING "+$(this).attr('save_price'));
  // end //

  $.session.set("sub_prod_id", $(this).find('.sub_prod').attr('prod-id'));
  
  // 02-12-2021 //
  var current_sub_pack = $(this).attr('sub_option');
  $('#pack').val(current_sub_pack+'-Pack');
  $(".pro_jar_one").each(function() {
  	$(this).removeClass("defSelPriceOne");
    $(this).removeClass("act_blu");
    var one_time_pack = $(this).attr('onetime_option');
    if(current_sub_pack == one_time_pack)
    {
      	$(this).closest('.radio-type_wrap').find('.pro_jar_one').removeClass('act_blu');
        $(this).addClass('act_blu');
        $('.now_price_one').html('$'+$(this).attr('data-price-one'));
        $('.old_prce_one').html('<s>$'+$(this).attr('old-price-one')+'</s>');
        $('.save_prc_one').html("You're Saving $"+$(this).attr('save_price'));

        /* var onetime_option = $(this).attr('onetime_option');
        if(onetime_option == 2 || onetime_option == 3){
            $('.one_time_purchase_content').show();
        }
        else{
            $('.one_time_purchase_content').hide();
        } */
    }
  
  });
  // END //
  
});
 


var redirect_link = '';
$(document).ready(function(e) {
  var days_select = 30;
  
  //set subscription initial product  
  $.session.set("sub_prod_id", $('.init-sub-prod').attr('prod-id'));
  
  //set subscription initial duration to 30 days  
  $.session.set("sub_duration", 30);    
  $.session.set("upsell_added", "no");
  

    $('.main_btn_checkout').click(function(e) {
        
    $.getJSON('/cart', function (results) {
      var has_subscription_product = false;
      $.each(results.items, function (i, item) {
        if( !has_subscription_product ){
          if(item.properties!== null){
            $.each(item.properties, function (j, property) {
              if(j=='shipping_interval_frequency'){
              	has_subscription_product = true;
              }          
            });
          }
        }  
      });
      
      if( has_subscription_product ){      	 
        //alert(' sub product');
        window.location.href = getCartUrl();    
      }else{        
      	//alert('No  sub product ');
        window.location.href ='/checkout';
      }
    });
    
    
    //var type = $('#type').val();   
//     var type = 'subscription';
//     if (type=='one_time') {
//       window.location.href ='/checkout';
//     } else if(type=='subscription') {
//         window.location.href = getCartUrl();      
//     }
        
  });
  
});


    function getCartUrl() {

      function get_cookie(name){
       return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] 
      }
      do {
            token=get_cookie('cart');
      }
      while(token == undefined);

      var myshopify_domain='felix-fetch.myshopify.com'
      try { 
        var ga_linker = ga.getAll()[0].get('linkerParam') 
      } catch(err) {
       var ga_linker ='';
      }
      var customer_param = '{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}';

      return "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token="+token+"&"+ga_linker+"&"+customer_param;
    }

    


$('#mobMenuBtn_nav').click(function() {
    $('#show_menu').toggleClass("mobile_width");  
});

$('#show_menu li a').click(function() {
    $('#show_menu').removeClass("mobile_width");
});



$(window).scroll(function() {
    var scroll = $(window).scrollTop();
     //>=, not <=
    if (scroll >= 500) {
        //clearHeader, not clearheader - caps H
        $(".top_sec_nvs").addClass("sticky");
    } else {
      $(".top_sec_nvs").removeClass("sticky");
    }
}); //missing );

